import { Divider } from '@mui/material'
import { useContext } from 'react'
import { AppStateContext } from '../../../state/AppProvider'
import dayjs from '../../../utils/date'
import { FormFieldLabel } from '../../form/FormFieldLabel'
import { FileList } from '../FileComponentLegacy/FIleList'
import styles from '../FormStepsLegacy.module.css'
import { getValue } from '../helpers'

import { LegacyDisplayField } from '../LegacyDisplayField'
import setupDetailsLegacyStyles from './SetupDetailsLegacy.module.css'

export const SetupDetailsLegacy = () => {
  const appStateContext = useContext(AppStateContext)
  const setupDetails = appStateContext?.state.currentChat?.extended_data?.experiment?.setup_details
  const planningBasics = appStateContext?.state.currentChat?.extended_data?.experiment?.planning_basics

  return (
    <div className={styles.stepContainer}>
      <div className={styles.fieldContainerSpaced}>
        <LegacyDisplayField
          label="Experiment Start Date"
          value={
            setupDetails?.experiment_start_date?.field_value
              ? dayjs.utc(setupDetails?.experiment_start_date?.field_value).format('MM/DD/YYYY')
              : '-'
          }
        />
        <LegacyDisplayField
          label="Experiment End Date"
          value={
            setupDetails?.experiment_end_date?.field_value
              ? dayjs.utc(setupDetails?.experiment_end_date?.field_value).format('MM/DD/YYYY')
              : '-'
          }
        />
        <LegacyDisplayField
          label="Experiment Budget (USD)"
          value={getValue(setupDetails?.experiment_budget?.field_value)}
        />
        <LegacyDisplayField
          label="Leading KPI"
          value={getValue(planningBasics?.leading_kpi?.field_value)}
        />
      </div>
      <LegacyDisplayField
        label="Hypothesis"
        value={getValue(planningBasics?.hypothesis?.field_value)}
      />
      <div className={styles.fieldContainerSpaced}>
        <LegacyDisplayField
          label="E@S Learning Name"
          value={getValue(setupDetails?.learning_name?.field_value)}
        />
        <LegacyDisplayField
          label="Analytical Team"
          value={getValue(setupDetails?.analytical_team?.field_value)}
        />
      </div>
      <LegacyDisplayField
        label="Select additional learning if necessary"
        value={getValue(setupDetails?.additional_learning?.field_value)}
      />
      <div className={styles.sectionTitleContainer}>
        <Divider className={styles.divider} />
        <p className={styles.sectionTitle}>Campaign & Platform Details</p>
      </div>
      <LegacyDisplayField
        label="Campaign Name"
        value={getValue(setupDetails?.campaign_name?.field_value)}
      />
      <div className={styles.fieldContainer3Grid}>
        <LegacyDisplayField
          label="Campaign Objective"
          value={getValue(setupDetails?.campaign_objective?.field_value)}
        />
        <LegacyDisplayField
          label="Platform/Partner"
          value={getValue(setupDetails?.platform_partner?.field_value)}
          className={setupDetailsLegacyStyles.fieldItemSpan2}
        />
      </div>
      <div className={styles.fieldContainer3Grid}>
        <LegacyDisplayField
          label="Buying Type"
          value={getValue(setupDetails?.buying_type?.field_value)}
        />

        <LegacyDisplayField
          label="Exclusions"
          value={getValue(setupDetails?.exclusions?.field_value)}
        />
        <LegacyDisplayField
          label="Format"
          value={getValue(setupDetails?.format?.field_value)}
        />
      </div>
      <div className={styles.sectionTitleContainer}>
        <Divider className={styles.divider} />
        <p className={styles.sectionTitle}>Files Uploaded</p>
      </div>
      <ul>
        <li>If you have any questions about which the files uploaded, please contact support</li>
      </ul>
      <div>
        <FormFieldLabel text="Creative" />
        <div className={styles.fileListContainer}>
          <FileList
            files={setupDetails?.creatives?.field_value}
            field="creatives"
          />
        </div>
      </div>
      <div>
        <FormFieldLabel text="Overall Test Structure and Design" />
        <div className={styles.fileListContainer}>
          <FileList
            files={setupDetails?.overall_test_structure_and_design?.field_value}
            field="overall_test_structure_and_design"
          />
        </div>
      </div>
      <div>
        <FormFieldLabel text="Media Plan" />
        <div className={styles.fileListContainer}>
          <FileList
            files={setupDetails?.media_plan?.field_value}
            field="media_plan"
          />
        </div>
      </div>
      <div>
        <FormFieldLabel text="Budget Sufficiency Tool" />
        <div className={styles.fileListContainer}>
          <FileList
            files={setupDetails?.budget_sufficiency_tool?.field_value}
            field="budget_sufficiency_tool"
          />
        </div>
      </div>
      <div>
        <FormFieldLabel text="Mid-Campaign Report" />
        <div className={styles.fileListContainer}>
          <FileList
            files={setupDetails?.mid_campaign_report?.field_value}
            field="mid_campaign_report"
          />
        </div>
      </div>
    </div>
  )
}
